var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h1',[_vm._v("Usuario")]),_c('p',[_vm._v(_vm._s(_vm.user))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }